const BETA_SUB_DOMAIN = '.beta.letrus.com.br';

export const isProdEnvironment = process.env.NODE_ENV === 'production';
export const isBetaDomain = window.location.origin.includes(BETA_SUB_DOMAIN);

export const recaptchaKey =
  isProdEnvironment && !isBetaDomain
    ? process.env.REACT_APP_RECAPTCHA_SITE_KEY || ''
    : process.env.REACT_APP_DEV_RECAPTCHA_SITE_KEY || '';
